<template>
    <modal-form
        editTitle="Menü bearbeiten"
        createTitle="Neues Menü hinzufügen"
    >
        <table>
            <tr>
                <th><label for="title" class="label">Titel:</label></th>
                <td>
                    <div class="control">
                        <input type="text" id="title" class="input" v-model="form.title">
                    </div>
                </td>
            </tr>
            <tr>
                <th class="is-top"><label class="label">Menü:</label></th>
                <td>
                    <div class="control">
                        <!-- <textarea rows="5" v-model="form.content" @input="formatValue" wrap="hard" maxlength="100"></textarea>-->
                        <tip-tap
                            v-model="form.content"
                            isNotAlone
                            :menuItems="['fullscreen', 'bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'color', 'undo']"
                        />
                    </div>
                </td>
            </tr>
        </table>
    </modal-form>

</template>

<script>
import { TipTap } from '@components/form';
import TabForm from '../form' ;

const wrap = (s, w) => s.replace(
    new RegExp(`(?![^\\n]{1,${w}}$)([^\\n]{1,${w}})\\s`, 'g'), '$1\n'
);

export default {
    mixins: [TabForm],

    form: {
        title: '',
        content: '<ul><li></li></ul>',
        type: 'menu'
    },

    methods: {
        formatValue(event) {
            let lines = event.target.value.split("\n");
            let lineArray = [];
            lines.forEach(line => {
                lineArray.push(wrap(line, 20));
            })

            this.form.content = lineArray.slice(0,5).join("\n")
        }
    },

    property: 'infos',

    components: {
        TipTap
    }
}
</script>
